module.exports = Backbone.Model.extend({
    defaults: {
        openInformation: false,
    },
    toggleMoreInfo() {
        this.set('openInformation', !this.get('openInformation'));
    },
});
